import { render, staticRenderFns } from "./DemoSessionPage.vue?vue&type=template&id=25e08f4a&scoped=true"
import script from "./DemoSessionPage.vue?vue&type=script&lang=js"
export * from "./DemoSessionPage.vue?vue&type=script&lang=js"
import style0 from "./DemoSessionPage.vue?vue&type=style&index=0&id=25e08f4a&prod&scoped=true&lang=css"
import style1 from "./DemoSessionPage.vue?vue&type=style&index=1&id=25e08f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e08f4a",
  null
  
)

export default component.exports